export const getFilterOptionKey = (resource: string, field: string) => {
  return `${resource}.${field}`
}
